import React, { useState } from 'react';
import classNames from 'classnames';

import { Arrow } from '@/icons/index';
import SectionDescription from '@/ui/SectionDescription/SectionDescription';
import { SectionTitle } from '@/components/ui';
import styles from './Questions.module.scss';

const Question = ({ question, isSmall }) => {
  const [isActive, setActive] = useState(false);

  const handleClick = () => setActive((prev) => !prev);

  return (
    <div
      className={classNames(styles['question-item'], {
        [styles.active]: isActive,
        [styles['question-item--small']]: isSmall,
      })}
      itemScope
      itemType='http://schema.org/Question'
    >
      <div className={styles['question-item__caption']} onClick={handleClick}>
        <h2 className={styles['question-item__title']}>{question?.title}</h2>
        <span>
          <Arrow />
        </span>
      </div>
      {isActive && (
        <div
          className={styles['question-item__desc']}
          dangerouslySetInnerHTML={{ __html: question?.content }}
        />
      )}
    </div>
  );
};

const Questions = ({ questions, className, isSmall }) => {
  const renderQuestions = (item, index) => {
    return <Question question={item} key={index} isSmall={isSmall} />;
  };

  return (
    <div
      className={classNames(className, 'section')}
      itemScope
      itemType='http://schema.org/FAQPage'
    >
      {questions?.title && (
        <SectionTitle
          titleModify={classNames(styles.questions_faq__title, 'title--medium')}
        >
          {questions?.title}
        </SectionTitle>
      )}
      <div className={styles.questions}>
        {questions?.description && (
          <SectionDescription description={questions.description} />
        )}
        {questions?.sections?.length > 0 && (
          <div className={styles.questions__list}>
            {questions.sections.map(renderQuestions)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Questions;
